function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useOnWindowResize from '../../helpers/hooks/useOnWindowResize';
import getHeaderHeight from '../../helpers/getHeaderHeight';
import SidebarArticle from './SidebarArticle.react';
var Sidebar = function Sidebar() {
  var _page$sidebar3;
  var pages = useSelector(function (s) {
    return s.pages;
  });
  useOnWindowResize({
    onResize: function onResize(_ref) {
      var width = _ref.width;
      return setWidth(width);
    }
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    sidebar = _useState4[0],
    setSidebar = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    articles = _useState6[0],
    setArticles = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  var clientEnv = useSelector(function (s) {
    return s.app.clientEnv;
  });
  useEffect(function () {
    $(document).on('slug-update-on-scroll', function (e, slug) {
      return scrollTo(slug);
    });
    $(document).on('scroll', function (e) {
      return handleOnScroll(e);
    });
    return function () {
      $(document).off('slug-update-on-scroll', function (e, slug) {
        return scrollTo(slug);
      });
      $(document).off('scroll', function (e) {
        return handleOnScroll(e);
      });
    };
  }, []);
  useEffect(function () {
    $('.sidebar').css({
      top: getHeaderHeight()
    });
    setTimeout(function () {
      $('.sidebar').css({
        top: getHeaderHeight()
      });
    }, 450);
    var url = pathname.replace(/\/$/, '');
    setPage(pages[url]);
  }, [pages, pathname]);
  useEffect(function () {
    var _page$sidebar, _page$sidebar2;
    page !== null && page !== void 0 && (_page$sidebar = page.sidebar) !== null && _page$sidebar !== void 0 && _page$sidebar.isVisible ? open() : close();
    setSidebar((page === null || page === void 0 ? void 0 : (_page$sidebar2 = page.sidebar) === null || _page$sidebar2 === void 0 ? void 0 : _page$sidebar2.isVisible) || false);
    setArticles((page === null || page === void 0 ? void 0 : page.articles) || []);
  }, [page]);
  var open = function open() {
    return $('#sidebar').css({
      left: 0
    });
  };
  var close = function close() {
    return $('#sidebar').css({
      left: -304
    });
  };
  var getSidebarScrollTop = function getSidebarScrollTop(_ref2) {
    var id = _ref2.id;
    var totalHeight = 0;
    var divs = $('#sidebar-content section');
    var match = false;
    divs.each(function () {
      if ('sidebar-' + id === $(this).attr('id')) match = true;
      if (!match) totalHeight += $(this).outerHeight();
    });
    return totalHeight;
  };
  var handleOnScroll = function handleOnScroll() {
    $('.sidebar').css({
      top: getHeaderHeight()
    });
  };
  useEffect(function () {
    if (sidebar && width > 1195) open();
    $('.sidebar').css({
      top: getHeaderHeight()
    });
  }, [width]);
  var scrollTo = function scrollTo(slug) {
    $('#sidebar-content').scrollTop(getSidebarScrollTop({
      id: slug
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "sidebar",
    className: "sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sidebar__content",
    id: "sidebar-content"
  }, articles.filter(function (x) {
    return clientEnv === 'local' || x.published.map(function (y) {
      return y.clientEnv;
    }).includes(clientEnv);
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    var article = x.articleID;
    if (!article) return null;
    return /*#__PURE__*/React.createElement(SidebarArticle, _extends({}, article, {
      onClick: function onClick(hash) {
        $('#sidebar-content').animate({
          scrollTop: getSidebarScrollTop({
            id: hash
          }) + 10
        }, 200);
        $.event.trigger('sidebar-article-click', hash);
      },
      key: "sidebar-article".concat(article._id)
    }));
  })), (page === null || page === void 0 ? void 0 : (_page$sidebar3 = page.sidebar) === null || _page$sidebar3 === void 0 ? void 0 : _page$sidebar3.isVisible) && /*#__PURE__*/React.createElement("div", {
    className: "sidebar__handle",
    onClick: function onClick() {
      $('#sidebar').position().left === 0 ? close() : open();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/sidebar-handle-2.png"
  })));
};
export default Sidebar;